<header class="sticky-top">
    <nav class="navbar navbar-expand-lg navbar-dark">
        <div class="container">
            <img src="assets/img/logo/logotipo_uoh-white.svg" alt="Logo Universidad de O'Higgins" class="img-fluid logo">

            <button class="navbar-toggler collapsed" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="navbar-collapse collapse" id="menu-home">
                <ul class="navbar-nav mr-auto w-100 justify-content-end">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle " href="#" id="dropdown04" data-bs-toggle="dropdown" aria-expanded="false">{{user}}</a>
                        <ul class="dropdown-menu" aria-labelledby="dropdown04">
                            <li><a class="dropdown-item" style="cursor:pointer" (click)="logout()">Cerrar sesión</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div class="offcanvas offcanvas-start" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
        <div class="offcanvas-header" style="background:linear-gradient(45deg, #004a93 0%, #3c96ff 100%)">
            <h5 class="offcanvas-title text-white" id="offcanvasWithBothOptionsLabel">Firma Digital - {{user}}</h5>
            <button type="button" class="btn-close text-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <app-sidebar></app-sidebar>
        </div>
        <hr>
        <div class="offcanvas-footer d-flex align-items-center">
            <a (click)="logout()" class="nav-link" id="logout">Cerrar sesión <i class="fa-solid fa-right-from-bracket"></i></a>
        </div>
    </div>
</header>
